import { useRouteMatch } from 'react-router';

import { Visit } from '@dreryk/egabinet-visit-frontend-api';

import { Heading, Scroll } from '@dreryk/react-components';

import { visitPaths } from '~libs.desktop.shared.paths';

import { referralTranslationKeys } from '../translations';

import { ReferralToDiagnosticExaminationForm } from './ReferralToDiagnosticExaminationForm/ReferralToDiagnosticExaminationForm';
import { ReferralToDiagnosticExaminationPanelLoader } from './ReferralToDiagnosticExaminationPanel.loader';
import { ReferralToDiagnosticExaminationRouteLeavingGuard } from './ReferralToDiagnosticExaminationRouteLeavingGuard';
import { ElectronicReferralToDiagnosticExaminationSendAction } from './ReferralToDiagnosticExaminationSendAction/ElectronicReferralToDiagnosticExaminationSendAction';
import { ReferralToDiagnosticExaminationSendAction } from './ReferralToDiagnosticExaminationSendAction/ReferralToDiagnosticExaminationSendAction';

type ReferralToDiagnosticExaminationPanelProps = {
   readonly visit: Visit;
};

export const ReferralToDiagnosticExaminationPanel = (props: ReferralToDiagnosticExaminationPanelProps): JSX.Element => {
   const electronic = Boolean(useRouteMatch({ path: visitPaths.ELECTRONIC_REFERRAL_TO_DIAGNOSTIC_EXAMINATION_PATH }));
   return (
      <Scroll testId={'referralToDiagnosticExamination'}>
         <ReferralToDiagnosticExaminationPanelLoader visitId={props.visit.id} electronic={electronic}>
            {({ referralToDiagnosticExaminationDraft }) => (
               <>
                  <Heading
                     testId={'diagnosticExamination'}
                     type={'h1'}
                     content={
                        electronic
                           ? referralTranslationKeys.referralType.DIAGNOSTIC_EXAMINATION_ELECTRONIC
                           : referralTranslationKeys.referralType.DIAGNOSTIC_EXAMINATION
                     }
                  />
                  <ReferralToDiagnosticExaminationForm
                     referralToDiagnosticExaminationDraft={referralToDiagnosticExaminationDraft}
                     visitDiagnoses={props.visit.diagnoses}
                     visitBeginDate={props.visit.beginDate}
                  >
                     {({ handleSubmit, handleSubmitDraft, formState, reset, trigger }) => (
                        <>
                           {electronic ? (
                              <ElectronicReferralToDiagnosticExaminationSendAction
                                 visitId={props.visit.id}
                                 patientId={props.visit.patient.id}
                                 handleSubmit={handleSubmit}
                                 onSuccess={reset}
                                 trigger={trigger}
                              />
                           ) : (
                              <ReferralToDiagnosticExaminationSendAction
                                 visitId={props.visit.id}
                                 handleSubmit={handleSubmit}
                                 onSuccess={reset}
                              />
                           )}
                           <ReferralToDiagnosticExaminationRouteLeavingGuard
                              formState={formState}
                              visitId={props.visit.id}
                              handleSubmitDraft={handleSubmitDraft}
                              electronic={electronic}
                           />
                        </>
                     )}
                  </ReferralToDiagnosticExaminationForm>
               </>
            )}
         </ReferralToDiagnosticExaminationPanelLoader>
      </Scroll>
   );
};
